
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSatelliteFull as ObiSatelliteFullElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-satellite-full.js';
 
 
 

 
 export const ObiSatelliteFull = createComponent({
   react: React,
   tagName: 'obi-satellite-full',
   elementClass: ObiSatelliteFullElement,
   events: {
     
   }
  });
 
 